var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.openThemeV3 ? _c("news-detail-theme3") : _c("news-detail-v3")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }